import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import { releaseAPI } from 'api/ReleaseNoteAPI'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IReleaseNote } from 'types/releaseNoteInterfaces'
import { chooseDBTranslation } from 'utils/translations'
import { convertToDisplayDate } from 'utils/utils'
import DOMPurify from 'dompurify'
import CardContentText from 'Components/reusable/CaleoCustomComponents/CardContentText'
import { orderBy } from 'lodash'
import { IError } from 'types/error'

/**
 * Renders the release notes component.
 *
 * @return {React.ReactElement} The rendered release notes component.
 * @notExported
 */
const ReleaseNotes: React.FC = () => {
  const { t, i18n } = useTranslation()
  const [notes, setNotes] = useState<IReleaseNote[]>()

  useEffect(() => {
    const controller = new AbortController()

    ;(async () => {
      try {
        const releaseNotes = await releaseAPI.getNotes(controller)
        setNotes(orderBy(releaseNotes, ['createdAt'], ['desc']))
      } catch (error) {
        const err = error as IError
        if (err.name !== 'CanceledError') {
          console.error(err)
        }
      }
    })()

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <Grid container sx={{ maxWidth: 1400, m: '0 auto', px: 1 }}>
      <Grid mt={1} size={12}>
        <CardContentText type="cardHeader">{t('releaseNotes.title')}</CardContentText>
      </Grid>
      <Grid container size={12}>
        {notes &&
          notes.length > 0 &&
          notes.map((note, i) => {
            return (
              <React.Fragment key={i}>
                {i !== 0 && (
                  <Grid size={12}>
                    <Divider />
                  </Grid>
                )}
                <Grid mt={3} size={12}>
                  <CardContentText type="darkSubHeader">
                    <span>{chooseDBTranslation(i18n, note).title}</span>
                  </CardContentText>
                </Grid>
                <Grid size={12}>
                  {`${t('admin.releaseNotes.createdAt')}: ${
                    note.createdAt ? convertToDisplayDate(note.createdAt) : '-'
                  } ${t('releaseNotes.version')}: ${note.version}`}
                </Grid>
                <Grid size={12}>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(chooseDBTranslation(i18n, note).note) }} />
                </Grid>
              </React.Fragment>
            )
          })}
        {!notes || (notes.length < 1 && <Grid size={12}>{t('releaseNotes.noNotes')}</Grid>)}
      </Grid>
    </Grid>
  )
}

export default ReleaseNotes
